import {useEffect, useMemo} from 'react'
import useEffectEvent from '../../hooks/use-effect-event'
import {useKindlyChat} from '../kindly-chat'
import {useZendeskChat} from '../zendesk-chat'

const ChatPriorityIntegration = () => {
    const kindly = useKindlyChat()
    const zendesk = useZendeskChat()

    const providers = useMemo(
        () => [
            {id: 'zendesk', ...zendesk},
            {id: 'kindly', ...kindly}
        ],
        [zendesk, kindly]
    )

    const anyEnabled = providers.some((p) => p.enabled)

    // "winner" for default visibility (page load / navigation)
    const winner = useMemo(() => {
        if (zendesk.enabled) return 'zendesk'

        if (kindly.enabled) return 'kindly'
        return null
    }, [zendesk.enabled, kindly.enabled])

    const applyVisibility = useEffectEvent(() => {
        // hide all first
        providers.forEach((p) => p.hide?.())

        if (!winner) return

        const w = providers.find((p) => p.id === winner)
        w?.requestLoad?.()
        w?.show?.()
    })

    useEffect(() => {
        applyVisibility()
    }, [winner, applyVisibility])

    // expose window.openChat
    const onOpenChat = useEffectEvent(() => {
        if (zendesk.enabled) {
            kindly.hide()
            zendesk.requestLoad()
            zendesk.show()
            zendesk.open()
            return
        }

        // old behavior: openChat means "open Kindly"
        kindly.requestLoad()
        kindly.show()
        kindly.open()
    })

    useEffect(() => {
        if (!anyEnabled) return
        window.openChat = onOpenChat
        return () => {
            delete window.openChat
        }
    }, [anyEnabled, onOpenChat])

    return null
}

export default ChatPriorityIntegration
